/**
 * VENDORED COPY — @directv-digital/dds.ui.dtv-button @ 5.0.64 (dtv-button.tsx).
 * upstream sha256 c27df73d5b5333bc5d66a02d4916f860d0c762a4dbceb4ebc6b021438a5da1dd
 *
 * WAT-11565. The TEXT is identical to the published source except this header
 * and the code marked `WAT-11565` inline, so a diff against the installed
 * package is the complete change:
 *
 *     diff -u node_modules/@directv-digital/dds.ui.dtv-button/dtv-button.tsx \
 *             src/components/video-lab/dtv-button/dtv-button.tsx
 *
 * That produces FOUR hunks. Hunk 1 is this header plus the eslint-disable block
 * and is repo-local — do NOT port it to DDS. Hunks 2, 3 and 4 are the change.
 *
 * Do not run a formatter over this file. It would rewrite ~900 lines of upstream
 * layout and bury hunks 2, 3 and 4. Measured with `eslint --no-inline-config`, the
 * file has 491 errors; 2 of those (`eqeqeq`, `prefer-template`) are already
 * silenced by upstream's own inline directives, so the block below silences the
 * other 489. Of those 489, 482 are layout rules a formatter would fix (indent
 * 282, comma-dangle 99, operator-linebreak 41, …) and 7 are not (curly 3,
 * camelcase 3, ban-ts-comment 1) — those are silenced, not fixable.
 *
 * The change: in the final fall-through branch only, non-navigation controls no
 * longer render as anchors and the modal/legal cases no longer hardcode
 * href="#". Hunk 4 is the consequence of that: a converted control gets its
 * keyboard focus ring restored, because the ancestor `a:focus` rules its
 * consumers author stop matching once it is a <button> (see focusRingRestore).
 * Port BOTH parts back — dropping hunk 4 re-breaks the focus indicator on every
 * legal CTA. The `uxicon` and tertiary/filterchip branches above still default to
 * an anchor — see the SCOPE note at the patched branch. A webpack alias in
 * next.config.js points the bare package specifier here, for BOTH the server and
 * client compilations; a client-only alias would render an anchor during SSR and
 * a button on hydration.
 *
 * ⚠️ Same text, different module graph. Vendoring moves the file out of the
 * package's own node_modules, so three of its direct imports now resolve to the
 * top-level copies: analytics-service 4.3.93→4.3.94, dtv-theme 4.3.61→4.3.62,
 * react-equal-height 1.2.2→1.3.1 (all within-major). On the client the first two
 * were already forced top-level by the dedupe aliases in next.config.js, so only
 * react-equal-height actually changes there.
 *
 * ⚠️ The app pins this package as `~5.0.57`, a range: a future `yarn install`
 * can move the npm copy while the alias keeps serving THIS file, so the two
 * silently diverge. config/dtv-button-vendor-check.js fails the build when the
 * published dtv-button.tsx CONTENT diverges from this copy; a version-label move
 * that leaves the bytes identical only warns (that one broke the build on
 * 2026-08-12 — 5.0.63 through 5.0.69 all ship this same file). The permanent fix
 * is the DDS port-back follow-up, which deletes this file and the alias.
 */
/* eslint-disable eqeqeq */
// Upstream style, silenced rather than reformatted (see above). These rules fire
// only on code this repo did not write — which stops being true the moment
// anyone edits this file, so re-narrow the list if you do. `curly` and
// `camelcase` are the two that are not purely cosmetic.
/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable no-trailing-spaces */
/* eslint-disable object-property-newline */
/* eslint-disable arrow-parens */
/* eslint-disable space-infix-ops */
/* eslint-disable key-spacing */
/* eslint-disable brace-style */
/* eslint-disable curly */
/* eslint-disable camelcase */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable comma-spacing */
/* eslint-disable arrow-spacing */
/* eslint-disable padded-blocks */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable @typescript-eslint/ban-ts-comment */

// @ts-nocheck

import React, { useState, useEffect, useMemo } from "react";
import { validContent, omitProps, useBreakPoints } from "@directv-digital/dds.utils";
import { Analytics, GoogleAnalytics,LINK_POSITION_BODY, fireCtaClickEventGA4, fireCustomLinkClickGA, fireDataLayerEvent } from "@directv-digital/dds.services.analytics-service";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvAvatar, { AvtarVariant } from "@directv-digital/dds.ui.dtv-avatar";
import Button, { ButtonProps } from "@mui/material/Button";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import IconButton from "@mui/material/IconButton";
import { hasWindow } from "@directv-digital/dds.core.commons";
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import { EqualHeightElement } from "react-equal-height/clean";
import { IModalData, useGlobalModalContext } from "@directv-digital/dds.core.global-modal-context";
import DtvTypography from "@directv-digital/dds.ui.dtv-typography";
import Input from "@mui/material/Input";

// useScrollTrigger removed â€” replaced with passive scroll hook to eliminate forced reflow (INP fix)
import Link from "@mui/material/Link";
import type { TypographyVariants } from "@mui/material/styles";

import { useMiniPopupState } from "@directv-digital/dds.server.application-context";
// Passive scroll trigger â€” reads window.scrollY (cached, no forced reflow)
// instead of MUI's useScrollTrigger which reads document.body.scrollTop (forces layout)
const SCROLL_HYSTERESIS = 50;

const usePassiveScrollTrigger = (threshold = 0, enabled = true) => {
  const [triggered, setTriggered] = React.useState(() =>
    enabled && typeof window !== 'undefined' ? window.scrollY > threshold : false
  );
  const ticking = React.useRef(false);
  const lastScrollY = React.useRef(0);
  const lastTriggered = React.useRef(false);
  const peakScrollY = React.useRef(0);

  React.useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      setTriggered(false);
      lastTriggered.current = false;
      return;
    }
    const initialY = window.scrollY;
    lastScrollY.current = initialY;
    peakScrollY.current = initialY;
    const initialState = initialY > threshold;
    lastTriggered.current = initialState;
    setTriggered(initialState);

    let rafId: number;
    const handleScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      rafId = requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        let next = lastTriggered.current;
        if (currentScrollY > lastScrollY.current && currentScrollY > threshold) {
          peakScrollY.current = currentScrollY;
          next = true;
        } else if (peakScrollY.current - currentScrollY >= SCROLL_HYSTERESIS) {
          next = false;
        }
        if (next !== lastTriggered.current) {
          lastTriggered.current = next;
          setTriggered(next);
        }
        lastScrollY.current = currentScrollY;
        ticking.current = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(rafId);
    };
  }, [threshold, enabled]);

  return triggered;
};

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    text: false;
    contained: false;
    outlined: false;
    uxtextlight: true;
    uxtextdark: true;
    uxprimarydark: true;
    uxprimarylight: true;
    uxsecondarydark: true;
    uxsecondarylight: true;
    uxinactive: true;
    uximagelink: true;
    uxlink: true;
    uxtoggle: true;
    tertiarybutton_smalldark: true;
    secondarybutton_medium_ondark: true;
    secondarybutton_mediumlight: true;
    tertiaryicononlybuttondark: true;
    filterchiplight: true;
    secondaryicononlybuttondark: true;
    minimiseButtondark: true;
    standalonelinkdark: true;
    filterchip_ondark: true;
    tertiarybuttoniconstackedlight: true;
    floatingactionbuttondark: true;
    floatingactionbuttonMobiledark: true;
    tertiarybuttonlight:true;
  }
}

export type IDtvButtonVariation =
  | "uxprimary"
  | "uxsecondary"
  | "uxinactive"
  | "uxtext"
  | "uximagelink"
  | "uxicon"
  | "uxlink"
  | "tertiarybutton_small"
  | "secondarybutton_medium"
  | "secondarybutton_medium_on"
  | "tertiaryicononlybutton"
  | "filterchip"
  | "filterchip_on"
  | "secondaryicononlybutton"
  | "minimiseButton"
  | "tertiarybuttoniconstacked"
  | "standalonelink"
  | "floatingactionbutton"
  | "floatingactionbuttonMobile"
  | "uxtoggle"
  | "uxpromolapis"
  | "uxpromoozone"
  | "uxpromosun"
  | "uxpromomagenta"
  | "uxpromoyellow"
  | "uxpromodisabled"
  | "tertiarybutton"
  | "fusionlinkdark"
  | "fusionlinklight";

export type IDtvButtonVariationTypes =
  | "uxprimarydark"
  | "uxprimarylight"
  | "uxsecondarydark"
  | "uxsecondarylight"
  | "uxtextdark"
  | "uxtextlight"
  | "uxinactive"
  | "uximagelink"
  | "uxicon"
  | "uxlink"
  | "tertiarybutton_smalldark"
  | "secondarybutton_mediumlight"
  | "secondarybutton_medium_ondark"
  | "tertiaryicononlybuttondark"
  | "secondaryicononlybuttondark"
  | "tertiarybuttoniconstackedlight"
  | "minimiseButtondark"
  | "standalonelinkdark"
  | "filterchiplight"
  | "filterchip_ondark"
  | "floatingactionbuttondark"
  | "floatingactionbuttonMobiledark"
  | "uxtoggle"
  | "uxpromolapislight"
  | "uxpromoozonelight"
  | "uxpromosunlight"
  | "uxpromomagentalight"
  | "uxpromomagentadark"
  | "uxpromoyellowdark"
  | "uxpromodisabledlight"
  | "uxpromodisableddark"
  | "tertiarybuttonlight"
  | "fusionlinkdark"
  | "fusionlinklight";

export type IDtvMode = "dark" | "light";

const UX_PROMO = [
  "uxpromolapis",
  "uxpromoozone",
  "uxpromosun",
  "uxpromomagenta",
  "uxpromoyellow",
];

export interface IDtvButtonProps extends Omit<ButtonProps, "variant"> {
  id?: string;
  label?: any;
  variant?: IDtvButtonVariation;
  mode?: IDtvMode;
  disabled?: boolean;
  target?: string;
  targeturl?: string;
  ariaLabel?: string;
  analytics?: IDtvButtonAnalytics;
  legalUrl?: any;
  legalText?: any;
  onClick?: (e?: any) => void;
  googleAnalyticsData?: GoogleAnalytics;
  analyticsUseAsync?: any;
  position?: "inline" | "block";
  content?: string;
  component?: any;
  customize?: boolean;
  imageUrl?: string;
  startIconUrl?: string;
  startIconHoverUrl?: string;
  imageAlt?: string;
  clickFn?: () => any;
  iconSize?: AvtarVariant;
  modalData?: IModalData | any;
  modalType?: any;
  btnInfo?: string;
  icon?: any;
  toggleBtnClicked?: boolean;
  inline?: boolean;
  typographyVariant?: TypographyVariants;
  useParsedLabel?: boolean;
  readOnly?: string;
  ga4Analytics?: any;
  fontFamily?: string;
  promo?: string | any;
  secondaryLabel?: any;
  secondaryLabelColor?:any;
  aboveTheFold?: boolean;
  inlineIframe?: any;
}
export interface IDtvButtonAnalytics extends Analytics {
  linkDestination?: string;
  linkName?: string;
  linkPosition?: string;
}



 const omitPropsList = [
  "hoverBackgroundColor",
  "sxBackgroundColor",
  "sxColor",
  "backgroundColor",
  "channelCount",
  "ctaaccessibility",
  "ctaAccessibility"
 ]

export function DtvButton({
  id,
  label,
  variant,
  disabled,
  target,
  targeturl,
  ariaLabel,
  analytics,
  onClick,
  mode,
  legalUrl,
  legalText,
  sx,
  googleAnalyticsData,
  analyticsUseAsync,
  imageUrl,
  imageAlt,
  iconSize,
  modalData,
  modalType,
  customize,
  clickFn,
  component,
  icon,
  startIcon,
  endIcon,
  toggleBtnClicked,
  readOnly,
  content,
  inline,
  typographyVariant,
  useParsedLabel,
  startIconUrl,
  startIconHoverUrl,
  ga4Analytics,
  children,
  promo,
  secondaryLabel,
  secondaryLabelColor,
  aboveTheFold,
  ...remainingProps
}: IDtvButtonProps) {
  try {
    const otherProps = omitProps(remainingProps, omitPropsList)
    const { update: updateMiniPopupState } = useMiniPopupState() ?? {};
    const [mouseEnter, setMouseEnter] = useState(false);
    const [iconFocus, setIconFocus] = useState(false);
    const { downMd } = useBreakPoints({ tablet: DtvTheme.breakpoints.values.md });
    const { showModal } = useGlobalModalContext();
    const [hoverOpen, setHoverOpen] = useState(false);
    const [dataError, setDataError] = useState("");
    const isFAB = typeof variant === "string" && variant.startsWith("floatingactionbutton");
    const trigger = usePassiveScrollTrigger(0, isFAB && downMd);

    useEffect(()=>{
      if(hasWindow() &&
      targeturl?.includes?.("https") &&
      targeturl?.includes?.("directv.com") &&
      !targeturl?.includes?.(window?.location?.hostname)){
        setDataError("Error in CTA URL mapping")
      }
    },[])
    
    // Performance optimization: Memoize URL promo parameter to avoid repeated parsing on every click
    const urlPromo = useMemo(() => {
      if (typeof window === "undefined") return null;
      try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('promo');
      } catch (_e) {
        return null;
      }
    }, []); // Parse once per component mount

    const styles = {
      toggleButtonContainer: {
        backgroundColor: toggleBtnClicked
          ? colorPalette.lightLapis.main
          : colorPalette.white.main,
        border: `2px solid ${
          toggleBtnClicked ? colorPalette.ozone.main : colorPalette.white.main
        }`,
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "10px",
        display: "flex",
        flexGrow: "1",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        justifyContent: "flex-start",
        alignItems: {
          xs: "center",
          sm: "flex-start",
        },
        padding: {
          xs: "32px 0px 32px 0px",
          sm: "45px 11px 45px 25px",
          md: "45px 50px 48px 33px",
        },
        width: {
          xs: "41%",
          md: "41%",
        },
        minHeight: {
          xs: "auto",
          md: "220px",
        },

        "&:hover,&:focus": {
          backgroundColor: colorPalette.lightLapis.main,
        },
      },
      btnBadge: {
        position: "absolute",
        top: {
          xs: "-25px",
          sm: "-60px",
          md: "-65px",
        },
        left: {
          xs: "35%",
          sm: "40%",
        },
        width: {
          xs: "50px",
          sm: "91px",
          md: "91px",
        },
        "& img": {
          transform: "rotate(90deg)",
        },
      },
      btnIcon: {
        margin: {
          md: "0 0px 0 0px",
        },
        "& img": {
          width: {
            xs: "87px",
            sm: "110px",
            md: "145px",
          },
          height: {
            xs: "80px",
            sm: "100px",
            md: "130px",
          },
        },
      },
      btnContentContainer: {
        padding: {
          xs: "16px 10px 0 10px",
          sm: "0px 10px 0 10px",
          md: "10px 0px 0 15px",
          lg: "10px 10px 0 15px",
        },
      },
      btnContent: {
        color: colorPalette.jet.main,
        fontWeight: 600,
        letterSpacing: 0,
        textAlign: {
          xs: "center",
          sm: "left",
        },
      },
    };

    // Performance fix: Move event listener to useEffect with proper cleanup to prevent memory leaks
    useEffect(() => {
      if (variant !== "uxtoggle" || typeof window === "undefined") return;
      
      const handleKeydown = (evt: KeyboardEvent) => {
        const { activeElement } = document;
        if (activeElement?.id === "toggleCta1" && evt.key === "ArrowRight") {
          document?.getElementById("toggleCta2")?.focus();
        }
        if (activeElement?.id === "toggleCta2" && evt.key === "ArrowLeft") {
          document?.getElementById("toggleCta1")?.focus();
        }
      };
      
      window.addEventListener("keydown", handleKeydown);
      return () => window.removeEventListener("keydown", handleKeydown);
    }, [variant]);

    const buttonVariant = React.useMemo(() => {
      if (
        variant === "uximagelink" ||
        variant === "uxicon" ||
        variant === "uxlink" ||
        variant === "uxtoggle" ||
        variant === "fusionlinkdark"||
        variant === "fusionlinklight"
      ) {
        return variant;
      }
      if (
        (disabled || variant === "uxinactive") &&
        variant !== "secondarybutton_medium" &&
        variant !== "secondarybutton_medium_on"
      ) {
        if (variant && UX_PROMO.includes(variant)) {
          // eslint-disable-next-line prefer-template
          return ("uxpromodisabled" +
            (mode || "light")) as IDtvButtonVariationTypes;
        }
        return "uxinactive" as IDtvButtonVariationTypes;
       
      } else if (variant === "uxsecondary") {
        return (variant + (mode || "light")) as IDtvButtonVariationTypes;
      }
      return ((variant || "uxprimary") +
        (mode || "dark")) as IDtvButtonVariationTypes;
    }, [mode, variant, disabled]);

    const openModal = (modalOpenAnalytics) => {
      let modalProps: any = modalData;
      if (customize && clickFn) {
        (async () => {
          try {
            const response = await clickFn?.();
            modalProps = {
              content: response?.content,
              analytics: modalData?.analytics,
              modalOpenAnalytics
            };
            showModal?.(modalType, modalProps);
          } catch ( error) {
            console.error("Error occurred while opening modal:", error);
            showModal?.(modalType, { ...modalData, modalOpenAnalytics });
          }
        })();
      } else {
        showModal?.(modalType,  { ...modalProps, ...{ modalOpenAnalytics } });
      }
    };

    // Event handler for button clicks
    // Note: useCallback not needed here as this is a leaf component and the handler
    // depends on runtime event data. Standard event handler pattern is simpler and clearer.
    const handleClick = (e: any) => {
      const updatedAnalytics = analytics;

      // Generated by Copilot- Start - 2026-06-03
      // Fire GTM lead event for phone/call CTAs on any component using DtvButton
      if (targeturl?.startsWith('tel:')) {
        fireDataLayerEvent({ event: 'trackEvent', event_name: 'lead', lead_source: 'phone' });
      }
      // Generated by Copilot- End - 2026-06-03

      // Execute user onClick immediately (highest priority)
      if (onClick) {
        onClick(e);
      }
      
      // Performance optimization: Early return for simple navigation links (tel:, mailto:, sms:)
      // This avoids expensive analytics and promo operations for basic navigation
      // Note: Must check both promo prop AND urlPromo to avoid skipping promo logic
      const isSimpleNavigation = !analytics && !ga4Analytics && !modalData && !promo && !urlPromo &&
                                 targeturl?.match(/^(tel:|mailto:|sms:)/);
      if (isSimpleNavigation) {
        return;
      }
      
      // Handle modal logic
      if (modalData && modalType) {
        let modalOpenAnalytics;
        if((modalData?.url?.includes("channel-lineup/modal") || modalData?.url?.includes("channels/modal")) && updatedAnalytics){
          if(updatedAnalytics){
              updatedAnalytics.linkDestination = '/modal/channel-lineup/'
          }
          modalOpenAnalytics=  {
            dim_name : 'open', 
            dim_value : 'modal_channel lineup'
          }
        }
       
        if (modalType === "rightDrawer") {
          const dispatchTarget = e?.currentTarget || e?.target;
          if (dispatchTarget) {
            const openRightDrawer = new CustomEvent("openRightDrawer", {
              bubbles: true,
              detail: { url: modalData?.url },
            });
            dispatchTarget.dispatchEvent(openRightDrawer);
          }
        } else {
          openModal(modalOpenAnalytics);
        }
      }

      // Performance optimization: Defer analytics to prevent blocking the main interaction
      // This improves INP (Interaction to Next Paint) scores significantly
      
      // Capture event data synchronously before deferring (React event pooling)
      // The event object e will be nullified after this handler completes
      const linkNameFromEvent = e?.currentTarget?.innerText || "";
      
      const deferAnalytics = () => {
        if (ga4Analytics) {
          fireCtaClickEventGA4(ga4Analytics);
        }
        if (analytics) {
          const data = {
            ...updatedAnalytics,
            linkDestination: updatedAnalytics.linkDestination || targeturl,
            linkName: updatedAnalytics.linkName || linkNameFromEvent,
            linkPosition: updatedAnalytics.linkPosition || LINK_POSITION_BODY,
          };
          fireCustomLinkClickGA(data);
        }
      };
      
      // Use requestIdleCallback for better performance, fallback to setTimeout
      // Timeout set to 500ms to balance performance with analytics reliability
      // (prevents data loss if user navigates away quickly)
      // Note: Analytics are client-side only - skip on server-side rendering
      if (typeof window !== "undefined") {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(deferAnalytics, { timeout: 500 });
        } else {
          setTimeout(deferAnalytics, 0);
        }
      }
      // Server-side: Skip analytics entirely (they won't work and aren't needed during SSR)
      
      // Handle promo logic using pre-parsed URL parameter
      if (typeof window !== "undefined") {
        if(urlPromo){
          sessionStorage.setItem("promo", urlPromo);
        } else if (promo) {
          if (updateMiniPopupState) {
            updateMiniPopupState(true);
          }
          sessionStorage.setItem("promo", promo);
        }
      }
    };

    if (variant === "uxtoggle") {
      return (
        <Button
          id={id}
          onClick={handleClick}
          sx={{ ...styles.toggleButtonContainer }}
          {...googleAnalyticsData}
        >
          {toggleBtnClicked && (
            <DtvBox sx={{ ...styles.btnBadge }}>
              <img alt="toggle-chevron" src="https://www.directv.com/dtvassets/global/icons/component-controls/toggle-chevron-glyph-icon.svg" />
            </DtvBox>
          )}
          {imageUrl && (
            <EqualHeightElement name="button-icon">
              <DtvBox sx={{ ...styles.btnIcon }}>
                <img src={imageUrl}  alt={imageAlt || "button-image"} />
              </DtvBox>
            </EqualHeightElement>
          )}

          <DtvBox sx={{ ...styles.btnContentContainer }}>
            <EqualHeightElement name="button-subheading">
              <DtvTypography
                variant="subhead2"
                component="div"
                sx={{ ...styles.btnContent }}
              >
                {label}
              </DtvTypography>
            </EqualHeightElement>
            <EqualHeightElement name="button-subheading2">
              <DtvTypography
                component="div"
                variant="body2"
                sx={{
                  color: colorPalette.jet.main,
                  textAlign: { xs: "center", sm: "left" },
                  marginTop: { xs: "10px", sm: "8px" },
                  fontSize: "16px",
                }}
              >
                {content}
              </DtvTypography>
            </EqualHeightElement>
          </DtvBox>
        </Button>
      );
    }

    if (buttonVariant === "fusionlinkdark" || buttonVariant === "fusionlinklight") {
      return (
        <Link
          href={targeturl} 
          onclick={handleClick}
          width="fit-content"
          target={target}
          sx={{
            display: "block",
            color: variant === "fusionlinklight" ? colorPalette.ozone.main : colorPalette.jet.main,
            textDecoration: 'none',
            borderRadius: "100px",
            "&:hover": {
              textDecoration: "underline",
            },
            "&.Mui-focusVisible": {
              outline: `2px solid ${colorPalette.focusOutline.blue}`,
              textDecoration: "underline",
            },
            "&:active":{
              color: variant === "fusionlinklight" ? colorPalette.jet.main : colorPalette.lapis.main,
            },
            ...sx
          }}
        >
          {label}
          </Link>
      );
    }
    
    if (buttonVariant === "uxicon") {
      return (
        <IconButton
          component={component || "a"}
          id={id}
          data-analytics={analytics?.tag}
          disabled={disabled}
          disableRipple
          disableFocusRipple
          aria-label={ariaLabel}
          {...(targeturl ? { href: targeturl, target } : {})}
          onClick={handleClick}
          sx={sx}
        >
          {startIcon || <DtvAvatar src={imageUrl} alt={imageAlt || ""} variant={iconSize} />}
        </IconButton>
      );
    }
    if (buttonVariant == "standalonelinkdark") {
      const customHandleClick = (e) => {
        handleClick(e);
        window.location.href = targeturl || "#";
      };
      const propsData: any = {
        variant: buttonVariant,
        onClick: customHandleClick,
        href: targeturl || "",
        target: target || "",
        rel: "noopener",
        id: id || "",
        sx,
        component,
      };
      return (
        <Input
          {...propsData}
          component="input"
          value={label}
          sx={{
            boxShadow: "none",
            color: "#2E70BD",
            textDecoration: "underline",
            justifyContent: "flex-start !important",
            backgroundColor: "transparent",
            width: "auto",
            height: "auto",
            marginRight: "auto",
            padding: "0px",
            fontSize: {
              xs: "16px",
              md: "18px",
            },
            fontFamily: "roboto-medium",
            "& input:focus-visible": {
              outline: `2px solid ${colorPalette.focusOutline.blue}`,
            },
          }}
          disableUnderline
          readOnly
        />
      );
    }
     
    const renderImage = () => {
      const value =
        buttonVariant === "filterchiplight" ||
        buttonVariant === "tertiarybuttoniconstackedlight" || 
        buttonVariant === "tertiarybuttonlight"
          ? iconFocus
          : mouseEnter;
      const urlHover = downMd ? "hoverImageUrlMobile" : "hoverImageUrl";
      const url = downMd ? "imageUrlMobile" : "imageUrl";
      const buttonIcon =
        buttonVariant === "secondaryicononlybuttondark"
          ? {
              height: {
                xs: "46px",
                sm: "48px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              width: {
                xs: "46px",
                sm: "48px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "12px",
                sm: "12px",
                md: "0px",
              },
            }
          : buttonVariant === "filterchiplight"
          ? {
              height: {
                xs: "32px",
                sm: "32px",
                md: "32px",
                lg: "32px",
                xl: "32px",
              },
              width: {
                xs: "32px",
                sm: "32px",
                md: "32px",
                lg: "32px",
                xl: "32px",
              },
              mr: {
                xs: "20px",
                sm: "26px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "20px",
                sm: "20px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },
            }
          : buttonVariant === "tertiarybutton_smalldark"
          ? {
              pr: "0",
              height: {
                xs: "16px",
                sm: "15px",
                md: "16px",
                lg: "16px",
                xl: "16px",
              },
              width: "16px",
              mr: "10px",
              color: {
                md: colorPalette.jet.main,
                lg: colorPalette.jet.main,
                xl: colorPalette.jet.main,
              },
            }
          : buttonVariant === "minimiseButtondark"
          ? {
              pr: "0",
              height: "24.0px",
              width: "24.0px",
              border: "0",
              color: {
                md: colorPalette.jet.main,
                lg: colorPalette.jet.main,
                xl: colorPalette.jet.main,
              },
            }
          : buttonVariant === "tertiaryicononlybuttondark"
          ? {
              pr: "0",
              height: "24.0px",
              width: "24.0px",
              border: "0",
              color: {
                md: colorPalette.jet.main,
                lg: colorPalette.jet.main,
                xl: colorPalette.jet.main,
              },
            }
          : buttonVariant === "floatingactionbuttondark"
          ? {
              color: `${colorPalette.jet.main}`,
              height: {
                xs: 36,
                sm: 36,
                md: 36,
                lg: 36,
                xl: 36,
              },
              width: {
                xs: 36,
                sm: 36,
                md: 36,
                lg: 36,
                xl: 36,
              },
              m: "0px 6px 0px 0px",
              fontSize: {
                xs: "14px",
                sm: "14px",
              },
              border: `1.5px solid ${colorPalette.jet.main}`,
              borderRadius: "100%",
            }
          : buttonVariant === "tertiarybuttoniconstackedlight"
          ? {
              color: colorPalette.jet.main,
              height: {
                xs: "40.63px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              width: {
                xs: "38.88px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              mr: {
                xs: "0px",
                sm: "5px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "12px",
                sm: "0px",
              },
              fontSize: {
                xs: "14px",
                sm: "14px",
              },
              border: "0px",
              borderRadius: "100%",
              // TODO: check right margin
              "& .MuiButton-startIcon": {
                margin: "0 !important",
              },
            }
            : buttonVariant === "tertiarybuttonlight"
            ? {
                color: colorPalette.jet.main,
                height: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px",
                  lg: "20px",
                  xl: "20px",
                },
                width: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px",
                  lg: "20px",
                  xl: "20px",
                },
                mr: {
                  xs: "0px",
                  sm: "5px",
                  md: "0px",
                  lg: "0px",
                  xl: "0px",
                },
                ml: {
                  xs: "12px",
                  sm: "0px",
                },
                fontSize: {
                  xs: "14px",
                  sm: "14px",
                },
                border: "0px",
                borderRadius: "100%",
                // TODO: check right margin
                "& .MuiButton-startIcon": {
                  margin: "0 !important",
                },
              }
          : buttonVariant === "filterchip_ondark"
            ?{
              color: colorPalette.jet.main,
              height: {
                xs: "20px",
                sm: "24px",
                md: "28px",
                lg: "36px",
                xl: "36px",
              },
              width: {
                xs: "20px",
                sm: "24px",
                md: "28px",
                lg: "36px",
                xl: "36px",
              },
              mr: {
                xs: "0px",
                sm: "5px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "12px",
                sm: "0px",
              },
              fontSize: {
                xs: "14px",
                sm: "14px",
              },
            //  border: `2px solid ${colorPalette.jet.main}`,
              borderRadius: "100%",
              // TODO: check right margin
              "& .MuiButton-startIcon": {
                margin: "0 !important",
              }
             }
          : buttonVariant === "secondarybutton_medium_ondark"
          ? {
              color: colorPalette.jet.main,
              height: {
                xs: "40.63px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              width: {
                xs: "38.88px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              mr: {
                xs: "0px",
                sm: "5px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "12px",
                sm: "0px",
              },
              fontSize: {
                xs: "14px",
                sm: "14px",
              },
              borderRadius: "100%",
              "& .MuiButton-startIcon": {
                margin: "0 !important",
              },
            } : {
              color: colorPalette.jet.main,
              height: {
                xs: "40.63px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              width: {
                xs: "38.88px",
                sm: "36px",
                md: "36px",
                lg: "36px",
                xl: "36px",
              },
              mr: {
                xs: "0px",
                sm: "5px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              ml: {
                xs: "12px",
                sm: "0px",
              },
              fontSize: {
                xs: "14px",
                sm: "14px",
              },
              border: `2px solid ${colorPalette.jet.main}`,
              borderRadius: "100%",
              // TODO: check right margin
              "& .MuiButton-startIcon": {
                margin: "0 !important",
              },
            };
      if (value) {
        return icon?.[urlHover] || icon?.[url] ? (
          <DtvBox
            component="img"
            sx={buttonIcon}
            src={icon?.[urlHover] || icon?.[url] || ""}
            alt={imageAlt || ""}
          />
        ) : (
          <></>
        );
      }
      if (buttonVariant === "floatingactionbuttondark" && trigger && downMd) {
        return (
          <DtvBox
            component="img"
            sx={buttonIcon}
            src={icon?.[urlHover] || icon?.[url] || ""}
            alt={imageAlt || ""}
          />
        );
      }
      if (!value) {
        return icon?.imageUrl ? (
          <DtvBox
            component="img"
            sx={buttonIcon}
            src={icon?.imageUrl}
            alt={imageAlt || ""}
          />
        ) : (
          <></>
        );
      }
    };
    if (
      buttonVariant === "tertiarybutton_smalldark" ||
      buttonVariant === "tertiaryicononlybuttondark" ||
      buttonVariant === "secondaryicononlybuttondark" ||
      buttonVariant === "minimiseButtondark" ||
      buttonVariant === "filterchiplight" ||
      buttonVariant === "secondarybutton_mediumlight" ||
      buttonVariant === "secondarybutton_medium_ondark" ||
      buttonVariant === "filterchip_ondark" ||
      buttonVariant === "floatingactionbuttondark" ||
      buttonVariant === "tertiarybuttoniconstackedlight" ||
      buttonVariant === "floatingactionbuttonMobiledark" ||
      buttonVariant === "tertiarybuttonlight"
    ) {
      const propsData: any = {
        variant:
          buttonVariant === "floatingactionbuttondark" && trigger && downMd
            ? "floatingactionbuttonMobiledark"
            : buttonVariant,
        onClick: handleClick,
        rel: "noopener",
        id: id || "",
        sx,
        component
      };
      const getLabel = (p_label) => {
        const supScripts = ["Â®", "<sup>", "<br/>"];
        const flag = supScripts.some((item) => p_label?.includes(item));
        return flag ? (
          <DtvTypography variant="body2medium">
            {" "}
            {validContent(p_label)}
          </DtvTypography>
        ) : (
          p_label || ""
        );
      };
      return (
        <Button
          {...propsData}
          onMouseEnter={() => setMouseEnter(true)}
          onMouseLeave={() => setMouseEnter(false)}
          onFocus={() => setIconFocus(true)}
          onBlur={() => setIconFocus(false)}
          component={component || "a"}
          role={component === 'button' ? 'button' : 'link'}
          {...(component !== 'button' && targeturl
            ? { href: targeturl, target }
            : component === 'button'
            ? {
               // href: "#",
                onClick: (e) => {
                  propsData?.onClick();
                  e?.preventDefault?.();
                },
              }
              :{
                href: "#",
                onClick: (e) => {
                  propsData?.onClick();
                  e?.preventDefault?.();
              },
            })}
          disabled={disabled}
          {...(readOnly ? { readOnly: "readonly" } : {})}
          {...(!startIcon && !endIcon ? { startIcon: renderImage() } : {})}
          {...googleAnalyticsData}
        >
          {getLabel(label)}
        </Button>
      );
    }
    // WAT-11565: a control that opens a modal is not a link, nor is a legal-text
    // CTA (whose own handler calls preventDefault so the href never navigates),
    // nor is one with no destination at all. Rendering those as anchors
    // put them in GTM's built-in Just Links trigger, so a UI toggle ran the whole
    // gtm.linkClick tag chain and fired Campaign Manager conversions (measured on
    // prod home 2026-08-10: hamburger 118.2ms of GTM listener time + 4 conversions).
    //
    // SCOPE — this fix covers THIS fall-through branch only. That is every
    // variant NOT caught by an earlier guard, i.e. everything except uxtoggle*,
    // fusionlinkdark/light, uxicon, standalonelinkdark, and the
    // tertiary/filterchip/minimise/FAB list. So it covers the home-page controls
    // (uxprimary*, uxlink, uxtext*) but also uximagelink, uxsecondary*,
    // uxinactive and uxpromodisabled* — read the buttonVariant useMemo plus the
    // branch guards above, not this sample list, if it matters to you.
    //
    // Two earlier branches still default to an anchor and are deliberately
    // untouched:
    //   • the `uxicon` branch — renders <a> with no href when targeturl is absent
    //     (live: genre-preview-tool, channel-pack-lineup — neither on home)
    //   • the tertiary/filterchip/minimise/FAB branch — still emits href="#"
    // Both carry the same GTM defect and are queued for the DDS port-back, which
    // is where a single shared helper belongs. Do not read the header comment as
    // claiming this component never renders a non-navigation anchor: it still can.
    //
    // Removing href is the load-bearing half: MUI ButtonBase does
    //   if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent
    // so it switches `component` back to an anchor whenever href is present and
    // flipping the default alone would be a no-op. The branches below drop the
    // hardcoded href="#" as well.
    //
    // An explicit `component` prop from a consumer still wins, and anything that
    // is not the native "button" keeps the old href="#" — a bare "a", but also a
    // component REFERENCE such as next/link, which needs href and would throw
    // without it. Not a focus concern (ButtonBase defaults tabIndex to 0 either
    // way and adds role="button" to an href-less non-button); the point is that a
    // consumer naming its own element has a contract this change has not audited,
    // so only the native button drops href.
    //
    // KNOWN BEHAVIOUR CHANGE beyond the tag name: for the disabled family
    // (`disabled`, uxinactive, uxpromodisabled*) MUI now emits a real `disabled`
    // attribute instead of aria-disabled + tabIndex=-1, because that is what
    // ButtonBase does once the element is a native button. A disabled <button>
    // dispatches no events at all, where the old anchor still did. That is the
    // correct semantics for a control that was never a link, and the spec pins
    // it, but it is a change and not only a cosmetic one.
    const isModalTrigger = Boolean(modalData && modalType);
    const isLegalTrigger = Boolean(legalUrl || legalText?.content);
    const isNavigation = !isModalTrigger && !isLegalTrigger && Boolean(targeturl);
    const resolvedComponent = component || (isNavigation ? "a" : "button");
    const keepsLegacyHref = resolvedComponent !== "button";
    // WAT-11565 focus ring. dds.ui.dtv-text hands a variant-less legal CTA
    // `sx={{ "&:focus": { outline: "none" } }}` (dtv-text.tsx:115). While the
    // control was an <a>, a component-scoped `a:focus` rule (video-marquee.tsx:592,
    // specificity 0,2,1) outranked that `none` and painted the ring. As a native
    // <button> the ancestor rule stops matching, the `none` ties the theme's own
    // 0,2,0 `:focus-visible` ring and wins on order, and the control is left with
    // NO keyboard focus indicator — measured on /sports/ Add'l Terms as
    // `outline: rgb(18,18,18) none 3px`.
    //
    // Two conditions, both necessary, because a wider restore does visible damage:
    //
    //  - `!component && !isNavigation` is the literal set this ticket converted.
    //    `resolvedComponent === "button"` is NOT the same test: with an explicit
    //    `component="button"` plus a targeturl the href survives and ButtonBase
    //    force-switches the element back to an <a> (see the href comment below),
    //    so that test would paint a ring onto an anchor.
    //  - the consumer must actually be turning the ring off. sx beats the theme's
    //    variant styles, so restoring unconditionally would repaint EVERY
    //    non-navigation uxtext/uxlink/uximagelink control from the theme's
    //    focusOutline.blue (#3885E1) to this hex, while its navigating twin kept
    //    the old colour — two focus colours for one variant on one page — and
    //    would hand uxprimary/uxsecondary a ring the theme never gave them.
    //
    // Colour is blue[600] = #2E70BD because that is what the affected controls
    // paint in production today (video-marquee, plan-card, acq-compare and
    // offer-cards all author that hex against the anchor). Offset 1px matches the
    // same production measurement.
    const sxObject = sx && !Array.isArray(sx) && typeof sx === "object"
      ? (sx as Record<string, any>)
      : undefined;
    const consumerClearsFocusRing = sxObject?.["&:focus"]?.outline === "none";
    const focusRingRestore = !component && !isNavigation && consumerClearsFocusRing
      ? {
        "&:focus-visible": {
          outline: `2px solid ${colorPalette.blue[600]}`,
          outlineOffset: "1px",
          // Consumer declarations still win. This is a JS object key, not a
          // cascade: a bare `"&:focus-visible": {...}` spread after `...sx`
          // REPLACES the consumer's whole block rather than losing to it on
          // specificity, so anything they authored has to be re-applied here.
          // Only a top-level key is merged; one nested under a media query stays
          // inside `...sx`, is emitted earlier and loses at equal specificity.
          ...sxObject?.["&:focus-visible"]
        }
      }
      : undefined;
    return (
      <>
        <Button
          component={resolvedComponent}
          id={id}
          {...(analytics?.tag) && {
            'data-analytics': analytics?.tag
          }}
          {...(dataError && {
            'data-error' : dataError
          })}
          variant={buttonVariant}
          disabled={disabled}
          disableRipple
          disableFocusRipple
          disableElevation
          aria-label={ariaLabel}
          startIcon={startIcon}
          endIcon={endIcon}
          {...(imageUrl && {
            startIcon: (
              <DtvAvatar
                alt={imageAlt}
                src={imageUrl}
                sx={{
                  width: "auto",
                  height:
                    variant === "uximagelink"
                      ? {
                          xs: "41px",
                          sm: "51px",
                        }
                      : "61px",
                  borderRadius: "0px",
                  "& .MuiAvatar-img, & .DtvAvatar-img": {
                    width: "auto",
                  },
                }}
              imgProps={{
                loading: aboveTheFold ? "eager" : "lazy",
                }}
              />
            ),
            })}
          {...((startIconHoverUrl || startIconUrl) && {
            onMouseEnter: () => {
              setHoverOpen(true);
            },
            onMouseLeave: () => {
              setHoverOpen(false);
            },
            startIcon: (
              <DtvAvatar
                src={
                  hoverOpen
                    ? startIconHoverUrl || startIconUrl
                    : startIconUrl || ""
                }
                sx={{
                  width: { xs: "20px", md: "20px" },
                  height: { xs: "20px", md: "20px" },
                }}
                imgProps={{
                  role: "presentation",
                  alt: "",
                }}
              />
            ),
          })}
          {...(
            // WAT-11565: same two predicates as the resolvedComponent derivation
            // above, reused rather than repeated — if these drifted apart, a
            // native button would get an href back and ButtonBase would silently
            // flip it to an anchor again (ButtonBase.js:254), restoring the bug.
            isModalTrigger
              ? { ...(keepsLegacyHref ? { href: "#" } : {}), onClick: (e) => { e.preventDefault(); handleClick(e); } }
              : isLegalTrigger
                ? { ...(keepsLegacyHref ? { href: "#" } : {}), onClick: (e) => { e.preventDefault(); handleClick(e); } }
                // This arm keeps the href unconditionally, so a consumer that
                // passes BOTH component="button" and a targeturl still gets an
                // anchor (ButtonBase force-switches on href). That is deliberate
                // and unchanged from upstream: nothing in this branch navigates
                // programmatically — handleClick does not, and the only
                // window.location assignment in the file belongs to the
                // standalonelinkdark variant — so dropping the href here would
                // hand that consumer a button that goes nowhere. No call site in
                // this app passes the pair today; the spec pins the behaviour.
                : targeturl
                  ? { href: targeturl, target, onClick: handleClick }
                  : { onClick: handleClick }
          )}
          {...googleAnalyticsData}
          sx={{
            width: {
              xs:
                inline || variant === ("uxtext" as IDtvButtonVariation)
                  ? "auto"
                  : "100%",
              sm: "auto",
              md: "auto",
              lg: "auto",
              xl: "auto",
            },
            textAlign: "center",
            ...(secondaryLabel && {
              display: "block"
            }),
            ...(typographyVariant && { typography: typographyVariant }),
            ...sx,
            // Declared after ...sx on purpose: same 0,2,0 specificity, later in
            // source, so it beats dtv-text's incoming `outline: none` WITHOUT
            // outranking the component-scoped `& a:focus, & button:focus` rules
            // (0,2,1) that plan-card and acq-compare use for their own ring. A
            // doubled `&&` would win those too and silently recolour them.
            // See focusRingRestore above for why it is built there.
            ...focusRingRestore
          }}
          {...(readOnly ? { readOnly: "readonly" } : {})}
          {...otherProps}
        >
          {useParsedLabel ? validContent(label) : label}
          { secondaryLabel &&
            <DtvBox sx={{
              fontSize: "14px",
              fontWeight: "500",
              color: secondaryLabelColor || "inherit",
              padding: "2px 0 0 0"
            }}>
              {secondaryLabel}
              </DtvBox>
          }
          {children}
        </Button>
      </>
    );
  } catch (error) {
    return <ErrorDisplay error={error} component="DTV Button" />;
  }
}



